/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-12-04 09:48:00
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-12-06 10:51:13
 * @FilePath: /dbrank_b/src/routes/cms/components/EditBlock/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import { Button, Input } from '../FormElement';
import PropTypes from 'prop-types';
import BrandTag from '../BrandTag';
import { trim } from 'lodash';
import classNames from 'classnames';


class EditBlock extends React.Component {
  ref;
  static propTypes = {
    isEdit: PropTypes.bool,
    title: PropTypes.string,
    content: PropTypes.array,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
  }

  state = {
    value: '',
    visible: false,
    showBtn: true,
  }

  componentDidMount() {
    this.setShow();
  }

  componentWillReceiveProps(nextProps){
    const { isEdit} = this.props;
    if (nextProps.isEdit !== isEdit && !nextProps.isEdit) {
      setTimeout(() => {

        this.setShow();
      },10)
    }
  }
  

  setShow = () => {
    if (this.ref) {
      this.setState({
        showBtn: this.ref.scrollHeight > 75
      })
      console.log(this.ref);
      console.log(this.ref.clientHeight, this.ref.scrollHeight);
    }
  }

  handleChange = (e) => {
    const { isEdit } = this.props;
    if (isEdit) {
      this.setState({
        value: e.target.value,
      })
    }
  }

  handleDel = (index, name) => {
    const { isEdit, onChange } = this.props;
    if (isEdit) {
      onChange && onChange('del', name, index)
    }
  }

  handleAdd = () => {
    const { isEdit, onChange, content } = this.props;
    const { value } = this.state;
    if (isEdit) {
      const val = trim(value);
      if ((content || []).includes(val)) {
        alert('已经存在' + val);
        return;
      }
      onChange && onChange('add', val)
      this.setState({ value: '' });
    }
  }

  save = () => {
    const { isEdit, onSave } = this.props;

    if (isEdit) {
      onSave && onSave();
    }
  }

  
  render () {
    const { title, content = [], isEdit } = this.props;
    const { value, visible, showBtn } = this.state;

    return (
      <div className={s.container}>
        <div className={s.head}>
          <div className={s.title}>
            {title}
          </div>
          <div className={s.title}>
            <Button 
              style={{ display: !isEdit && showBtn ? 'block' : 'none'}}
            onClick={() => {
              this.setState({
                visible: !visible
              })
            }}>{!visible ? '展开' : '收起'}</Button>
          </div>
        </div>
        <div ref={ref => this.ref = ref} className={classNames(s.body, s.textContainer, {[s.expand]: visible || isEdit})}>
          {!content || content.length < 1 && <div className={s.empty}>暂无数据</div>}
          {content.map((item, index) => (
            <BrandTag
              key={item}
              close={isEdit}
              className={s.tag}
              onClick={() => this.handleDel(index)}>
              {item}
            </BrandTag>
          ))}
        </div>

        <div className={s.foot} style={{ display: isEdit ? 'flex' : 'none'}}>
          <Input
            style={{ marginRight: 10 }}
            value={value}
            onChange={this.handleChange}  
          />
          <Button disabled={!(value.trim())} onClick={this.handleAdd}>添加</Button>
          <Button onClick={this.save} className={s.saveBtn}>保存</Button>
        </div>
      </div>
    )
  }
}

export default withStyles(s)(EditBlock)



// WEBPACK FOOTER //
// src/routes/cms/components/EditBlock/index.js